
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    PACKAGES_CREATE_PACKAGE_REQUEST,
    PACKAGES_UPDATE_PACKAGE_REQUEST,
    PACKAGES_GET_PACKAGE_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { 
    packagesCreatePackageResult,
    packagesGetPackageResult,
    packagesUpdatePackageResult,
} from 'Redux/actions';


function* createRole({ payload }) {
    try {
        let QUERY = `
            mutation createRole ($projectId: enumProjectId!, $companyId: Int, $dealerId: Int, $name: String!, $description: String, $permissions: [PermissionInput]) {
                result: createRole (projectId: $projectId, companyId: $companyId, dealerId: $dealerId, name: $name, description: $description, permissions: $permissions) {
                    id
                    projectId
                    dealerId
                    name
                    description
                    isCustom
                    customOwner
                    roleModules {
                        id
                        roleId
                    }
                }
            }
        `;
        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(packagesCreatePackageResult(data.result))

    } catch (exc) {
        yield put(packagesCreatePackageResult())
        ExceptionManager(
            exc,
            "Modules/packages/.components/createEditPackage/redux/saga",
            "createRole",
        )
    }
}

function* updateRole({ payload }) {
    try {
        let QUERY = `
            mutation updateRole ($id: Int!, $name: String, $description: String, $permissions: [PermissionInput]) {
                result: updateRole (id: $id, name: $name, description: $description, permissions: $permissions) {
                    id
                    projectId
                    name
                    description
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(packagesUpdatePackageResult(data?.result));

    } catch (exc) {
        yield put(packagesUpdatePackageResult());
        ExceptionManager(
            exc,
            "Modules/packages/.components/createEditPackage/redux/saga",
            "updateRole",
        )
    }
}

function* getRole({ payload }) {
    try {
        let QUERY = `
            query getRole ($id: Int!) {
                result: getRole (id: $id) {
                    id
                    projectId
                    name
                    description
                    isCustom
                    roleModules {
                        id
                        roleId
                        moduleId
                        module {
                            id
                            projectId
                            code
                            userCode
                            name
                            groupName
                            parentModuleId
                            category
                            modulesCount
                        }
                        c
                        u
                        d
                        isDefault
                    }
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(packagesGetPackageResult(data?.result))

    } catch (exc) {
        ExceptionManager(
            exc,
            "Modules/packages/.components/createEditPackage/redux/saga",
            "getRole",
        )
    }
}

function* watchMethods() {
    yield takeEvery(PACKAGES_CREATE_PACKAGE_REQUEST, createRole);
    yield takeEvery(PACKAGES_UPDATE_PACKAGE_REQUEST, updateRole);
    yield takeEvery(PACKAGES_GET_PACKAGE_REQUEST, getRole);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}